<template>
  <div>
    <v-alert
      class="position: absolute; bottom: 0px; right: 0px;"
      :value="erro.ativo"
      type="error"
    >{{ erro.msg }}</v-alert>
    <v-btn
      small
      title="Importar rateios"
      fab
      color="blue-grey"
      style="float: right;"
      :loading="loadingImportacao"
      :disabled="condicaoParaAparecer"
      @click="enviarRateioClique()"
    >
      <v-icon>vertical_align_top</v-icon>
    </v-btn>
    <input
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      type="file"
      style="display: none;"
      ref="planilhas"
      @change="uploadDeRateios('planilhas')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import moedasMixin from "@/mixins/moedasMixin";
import axios from "axios";

export default {
  name: "importarRateios",
  mixins: [moedasMixin],
  props: {
    condicaoParaAparecer: {
      type: Boolean,
      default: false
    },
    tipoDeMoeda: {
      type: String,
      default: "BRL"
    },
    valorTotalRateio: {
      default: 0
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      arquivoCSV: [],
      erro: {
        ativo: false,
        msg: ""
      },
      loadingImportacao: false
    };
  },
  methods: {
    formatarCsv(csv) {
      csv = csv.split("\n");
      return csv;
    },
    montaContaGerencial(arrayPlanilha) {
      arrayPlanilha.map((itemArray, index) => {
        let contasGerenciaisCorretas = this.cacheCG.contasGerenciais.filter(
          itemRetorno => {
            return (
              itemRetorno.numero ==
              itemArray.contaGerencial.numero.replace(/\s/g, "")
            );
          }
        );

        if (contasGerenciaisCorretas.length == 0) {
          this.$store.commit(
            "snackErro",
            `Conta gerencial com o número ${itemArray.contaGerencial.numero} não encontrado pra essa conta gerencial.`
          );
          return (arrayPlanilha = []);
        }

        contasGerenciaisCorretas.map(itemCG => {
          let variavelCorreta;
          variavelCorreta = itemArray.contaGerencial.numero;
          if (itemCG.numero == variavelCorreta.replace(/\s/g, "")) {
            arrayPlanilha[index].contaGerencial.nome = itemCG.nome;
            arrayPlanilha[index].contaGerencial.id = itemCG.id;
          }
        });
      });
      return arrayPlanilha;
    },
    async verificaContasGerenciaisVuex(arrayRecebida) {
      if (arrayRecebida.length == 0) this.$emit("devolverDados", arrayRecebida);

      await Promise.all(
        arrayRecebida.map(async item => {
          if (
            this.cacheCG.idCentrosDeCustos.indexOf(item.departamento.id) == -1
          ) {
            await this.carregarContasGerenciais(item.departamento.id);
          }
        })
      ).then(s => {
        arrayRecebida = this.montaContaGerencial(arrayRecebida);
      });

      this.$emit("devolverDados", arrayRecebida);
      this.loadingImportacao = false;
    },
    async carregarContasGerenciais(idCC) {
      try {
        await axios({
          method: "get",
          url: `/contasgerenciais/centrodecustos/${idCC}`,
          responseType: "json",
          headers: {
            Authorization: `Bearer ${this.loggedUser.token}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(response => {
          this.$store.commit("setCC", {
            itemName: "cacheCG",
            arrayName: "contasGerenciais",
            content: response.data
          });
          this.$store.commit("setInArray", {
            itemName: "cacheCG",
            arrayName: "idCentrosDeCustos",
            content: idCC
          });
          return Promise.resolve(true);
        });
      } catch (e) {
        console.error("Ocorreu erro inesperado... " + e);
      }
    },
    carregarCentroDeCustos(dados) {
      let arrayLegal = [];
      let headerPadrao = [
        "Cod. Empresa",
        "N Conta Gerencial",
        "N Centro de Custo",
        "Valor"
      ];
      for (let i = 0; i < headerPadrao.length; i++) {
        let headersLoop = dados[0].split(";"); //pego headers
        if (
          headersLoop[i].replace(/\s/g, "") !==
          headerPadrao[i].replace(/\s/g, "")
        ) {
          this.$store.commit(
            "snackErro",
            `Encontramos um erro ao ler o cabeçalho da planilha. O cabeçalho ${headersLoop[i]} está escrito de forma errada.`
          );
          return (arrayLegal = []);
        }
      }
      dados.splice(0, 1);
      dados.map(async item => {
        let itemLoop = item.split(";");

        let nomeCentroDeCusto = "";
        let idDoCentroDeCusto = null;

        if (
          this.centroDeCustos.length == 0 ||
          this.centroDeCustos.length == undefined
        ) {
          this.$store.commit(
            "snackErro",
            "Centros de custos ainda não carregados, por favor selecione uma empresa ou aguarde carregamento."
          );
          return (arrayLegal = []);
        }

        if (itemLoop[2] != undefined) {
          if (itemLoop[2].length != 0) {
            let centroDeCustosCorretos = this.centroDeCustos.filter(item => {
              return item.centroDeCusto == itemLoop[2].replace(/\s/g, "");
            });

            if (centroDeCustosCorretos.length == 0) {
              this.$store.commit(
                "snackErro",
                `Centro de Custo com número ${itemLoop[2]} não encontrado pra essa empresa.`
              );
              return (arrayLegal = []);
            }
            centroDeCustosCorretos.map(meuItem => {
              if (meuItem.centroDeCusto == itemLoop[2].replace(/\s/g, "")) {
                nomeCentroDeCusto = meuItem.nome;
                idDoCentroDeCusto = meuItem.id;
              }
            });

            let valorDoItem = Number(
              this.converterValorStringEmNumero(itemLoop[3], this.tipoDeMoeda)
            );
            if (valorDoItem == 0) {
              this.$store.commit(
                "snackErro",
                `Centro de Custo com número ${itemLoop[2]} está com valor zerado.`
              );
              return (arrayLegal = []);
            }

            let objetoCorretoPraInserir = {
              contaGerencial: {
                numero: itemLoop[1]
              },
              valor: this.converterValorStringEmNumero(
                itemLoop[3],
                this.tipoDeMoeda
              )
            };

            objetoCorretoPraInserir.departamento = {
              centroDeCusto: itemLoop[2],
              nome: nomeCentroDeCusto,
              id: idDoCentroDeCusto
            };

            let temEsteItem = arrayLegal.filter(i => {
              let centroDeCustoIguais =
                i.departamento.centroDeCusto ==
                  itemLoop[2].replace(/\s/g, "") &&
                i.departamento.id == idDoCentroDeCusto;

              let contasGerenciaisIguais =
                i.contaGerencial.numero == itemLoop[1];

              return centroDeCustoIguais && contasGerenciaisIguais;
            });

            if (temEsteItem.length > 0) {
              this.$store.commit(
                "snackErro",
                `O centro de custo com o número ${itemLoop[2]} está duplicado na planilha.`
              );
              return (arrayLegal = []);
            } else arrayLegal.push(objetoCorretoPraInserir);
          }
        }
      });

      let valorTotalDoArquivoImportado = 0;
      arrayLegal.map(itemRateio => {
        valorTotalDoArquivoImportado += Number(itemRateio.valor);
      });
      if (
        Number(valorTotalDoArquivoImportado.toFixed(2)) >
        Number(this.valorTotalRateio)
      ) {
        this.$store.commit(
          "snackErro",
          `O total desse arquivo está maior que o valor do rateio.`
        );
        return (arrayLegal = []);
      }
      return arrayLegal;
    },
    resetArquivoAnterior() {
      const input = this.$refs.planilhas;
      input.type = "text";
      input.type = "file";
    },
    uploadDeRateios(nomeDoRef) {
      let arquivo = this.$refs[nomeDoRef].files[0];
      this.resetArquivoAnterior();

      var vm = this;
      this.resetarErro();
      this.loadingImportacao = true;

      var leitorArquivo = new FileReader();
      leitorArquivo.readAsText(arquivo);

      leitorArquivo.onload = async function(event) {
        var csv = event.target.result;
        vm.arquivoCSV = await vm.formatarCsv(csv);
        vm.arquivoCSV = await vm.carregarCentroDeCustos(vm.arquivoCSV);
        await vm.verificaContasGerenciaisVuex(vm.arquivoCSV);
      };
      leitorArquivo.onerror = function(evt) {
        if (evt.target.error.name == "NotReadableError") {
          this.$store.commit("snackErro", `Esse arquivo não é compatível.`);
        }
      };
    },
    enviarRateioClique() {
      this.$refs.planilhas.click();
    },
    resetarErro() {
      this.loadingImportacao = false;
      this.erro.ativo = false;
      this.erro.msg = "";
    }
  },
  computed: {
    ...mapState({
      contasGerenciais: state => state.contasGerenciais,
      centroDeCustos: state => state.centroDeCustos,
      loggedUser: state => state.loggedUser,
      cacheCG: state => state.cacheCG
    })
  },
  created() {}
};
</script>

<style scoped>
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: hsla(0, 0%, 16%, 0.12) !important;
}
</style>
